import { BaseResponse, createApi, CreateApiParams, VisitQueryParams, VisitSummary } from '../api';

declare const healConfig: any;

function createVisitsApi(params?: Partial<CreateApiParams>) {
  return createApi({ ...params, baseURL: healConfig.apiBaseUrl + '/admin' });
}

export function fetchVisit(visitCode: string, includes?: string[]) {
  const path = `/v1/visits/${visitCode}${includes ? `?include=${includes?.join(',')}` : ''}`;

  return createVisitsApi()
    .then((api) => api.get<BaseResponse<VisitSummary>>(path))
    .then((response) => {
      const visit = response.data?.data;
      if (response.ok && visit) return visit;

      return Promise.reject(new Error(response.data?.description || 'Something went wrong. Please refresh page to try again.'));
    });
}

export function fetchVisits(searchParams: VisitQueryParams) {
  return createVisitsApi({ hideMessage: true })
    .then((api) => api.get<BaseResponse<VisitSummary[]>>(`/v1/visits/`, searchParams))
    .then((response) => {
      const visits = response.data?.data;
      if (response.ok && visits) return visits;

      return Promise.reject(new Error(response.data?.description || 'Something went wrong. Please refresh page to try again.'));
    });
}

export function changeServiceCode(visitCode: string, newServiceCode: string) {
  return createVisitsApi({ hideMessage: true })
    .then((api) => api.post<BaseResponse<VisitSummary>>(`/v1/visits/${visitCode}/change-service-offering/${newServiceCode}`))
    .then((response) => {
      if (response.ok) {
        return true;
      }
      return Promise.reject(new Error(response.data?.description || 'Something went wrong. Please refresh page to try again.'));
    });
}
